import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import UserRestServices from '../../services/user-rest.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-consents',
	templateUrl: './modal-consents.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalConsentsComponent implements OnInit {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private dialogRef = inject(MatDialogRef<ModalConsentsComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.handleModalInit();
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleModalSubmit = this.handleModalSubmit;
	}
	
	handleModalInit() {
		this.vm.user = this.session.getSession().user;
		var origin: any = (this.vm.user && this.vm.user.origin) ? this.vm.user.origin : "minudoc.ee";
		var locale: any = this.vm.user?.deviceLanguage;
		this.vm.webUrl = this.config.getPublicWebUrl();
		if (origin == 'minudoc.ee') {
			switch (this.vm.user.deviceLanguage) {
				case 'et_EE':
					this.vm.webPathTos = '/kasutustingimused';
					this.vm.webPathPP = '/privaatsuspoliis';
					break;
				case 'ru_RU':
					this.vm.webPathTos = '/uslovija-ispolzovanija';
					this.vm.webPathPP = '/politika-konfidencialnosti';
					break;
				case 'fi_FI':
					this.vm.webPathTos = '/kayttoehdot';
					this.vm.webPathPP = '/tietosuojakaytanto';
					break;
				default:
					this.vm.webPathTos = '/terms-of-service';
					this.vm.webPathPP = '/privacy-policy';
			}
		} else {
			this.vm.webPathTos = '/terms-of-service';
			this.vm.webPathPP = '/privacy-policy';
		}
		this.vm.webTosLink = origin == 'siffi.com'
			? this.config.getSiffiPublicWebUrl(locale, this.vm.webPathTos)
			: this.vm.webUrl + this.vm.webPathTos;
		this.vm.webPPLink = origin == 'siffi.com'
			? this.config.getSiffiPublicWebUrl(locale, this.vm.webPathPP)
			: this.vm.webUrl + this.vm.webPathPP;
	}
	
	handleModalSubmit() {
		if (this.vm.processing) return;
		this.vm.processing = true;
		this.userRestServices.acceptConsentUpdates(
			(response) => {
				this.handleModalClose();
			},
			(error) => {
				console.error('Failed updating user consents', error);
				this.vm.processing = false;
			}
		);
	}
	
	handleModalClose() {
		this.dialogRef.close(this.vm.user);
	}
	
}
